import { Fragment } from 'react';
import { Icon } from './icon';

/**
 * Mockup `.breadcrumb`: 12px bold uppercase, letter-spacing 0.08em, gray-400,
 * chevron separators between segments. Read-only here (the mockup links were
 * decorative); rendered as plain text.
 */
export function Breadcrumb({ items }: { items: string[] }): JSX.Element {
  return (
    <div className="mb-2 flex items-center gap-1.5 text-[12px] font-bold uppercase tracking-[0.08em] text-[var(--m-fg-subtle)]">
      {items.map((item, i) => (
        <Fragment key={item}>
          {i > 0 && <Icon name="chevron-right" size={12} />}
          <span>{item}</span>
        </Fragment>
      ))}
    </div>
  );
}
